<style scoped>
	.mobileonly
	{
		display: none;
	}
	.menu-icons-wrapper
	{		
		overflow-x: scroll;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
		-ms-overflow-style: none;  /* IE and Edge */
  		scrollbar-width: none;  /* Firefox */	
		width: 85%;
	}
	.menu-icons-wrapper::-webkit-scrollbar {
		display: none;
	}
	.menu-icons
	{
		display: flex;
		/* flex-direction: row; */
		justify-content:space-between;
		height: 100%;
		padding: 0px 30px;		
	}
	.mi {
		border: 0px solid #333;
	}
	.mi-link
	{
		display: flex;
		justify-content: center;
		align-items: center;		
		height: 100%;
		opacity: 0.6;
		cursor: pointer;
		/* border: 1px solid green; 		 */
	}
	.mi-link.router-link-exact-active
	{
		opacity: 1 !important;
	}
	.mi-link:hover
	{
		opacity: 1;
	}

	.mi-img
	{
		width: 36px;
		height: auto;
	}
	.mi-label
	{
		/* max-width: 50px; */
		display: inline-block;
		margin-left: 7px;
		color:#545454;
		/* white-space:nowrap; */
	}

	
	@media only screen and (max-width: 1350px) {
		.menu-icons-wrapper
		{
			border: solid 0px red;
		}
		.menu-icons
		{
			padding: 0px 20px;		
		}
		.mi-img
		{
			width: 26px;height: auto;
		}
	}

	@media only screen and (min-width: 1600px) {
		.menu-icons-wrapper{
			width: 85%;
		}
		.menu-search{
			width: 15%;padding-left: 2%;
		}
	}
	@media only screen and (min-width: 1900px) {
		.menu-icons-wrapper{
			width: 80%;
		}
		.menu-search{
			width: 20%;padding-left: 2%;
		}
	}
	@media only screen and (min-width: 2400px) {
		.menu-icons-wrapper{
			width: 60%;
		}
		.menu-search{
			width: 40%;
			padding-left: 2%;
		}
	}


	/* 
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
	@media (min-width: 320px) and (max-width: 480px) {
	*/
	@media only screen 
	and (min-width: 320px) 
	and (orientation: portrait) 
	{
		.menu-bar{
			top:70px;
			height:60px;
		}
		.mobileonly{
			display: block;
		}		
		.menu-icons{
			display: none;
		}
		.menu-bar{
			margin-left: 20px;
			width: calc(100% - 40px);
		}
		.menu-icons-wrapper{
			width: 70px;
			text-align: center;
		}
		.menu-search{
			width: calc(100% - 80px);
		}
		.hamburger{
			margin: auto;
		}
	}

	/* Portrait ipad*/
	@media only screen 
	and (min-width: 820px) 
	and (max-width: 1025px) 
	and (orientation: portrait) 
	{
		.menu-bar
		{
			margin-left: 55px;
			width: calc(100% - 110px);
			top: 80px;					
		}
		.menu-search{
			width: calc(100% - 70px);
			max-width: 1024px;
		}
	}



</style>
<template>
	<div class="menu-bar">

		<div class="menu-icons-wrapper">
			<span class="hamburger mobileonly" :class="{active: overlay.active && overlay.type==='sortmenu'}" @click="toggleOverlay('sortmenu')"></span>
			<div class="menu-icons">	
				<div class="mi" v-for="(category,i) in menu_categories" :key="category.id" :data-index="i">
					<router-link :to="getLink(category)" :class="['mi-link', isInPageUrl(category) ? 'router-link-exact-active':'']">
						<img class="mi-img" :src="category.src">
						<span class="mi-label font-menubar" v-html="category.name"></span>
					</router-link>
				</div>
			</div>
		</div>
		
		<!-- <span class="hamburger" :class="{active: overlay.active && overlay.type==='sortmenu'}" @click="toggleOverlay('sortmenu')"></span> -->
		<!--			
		<transition name="fade" appear>
			<h4 v-if="resultsTitle" :class="['title', hasSubmenu ? 'has-submenu' : '']">
				<span v-html="resultsTitle"></span>
				<span
					v-if="!isSubmenu && filterName"
					:class="['result-label', submenu.active ? 'active' : '']"
					@[__event].prevent="toggleSub"
					>
					<span v-text="filterName"></span>
					<i v-if="hasSubmenu" :class="['fas', 'fa-caret-down']"></i>
				</span>
				<transition name="slide-down-up" appear>
					<div @click="submenu.active=false" v-show="!!submenu.active && childCatList.length>1" class="submenu">
						<router-link
							v-for="child in childCatList"
							:key="child.name"
							:to="{
								name: 'results-child',
								params: { category: activeCategory.name, subcat: child.name }
							}"
							v-text="child.name"
							>
						</router-link>
					</div>
				</transition>
			</h4>
		</transition>
		-->
		<search-box v-model="searchfilter" class="menu-search" type="menu" placeholder="SEARCH"></search-box>
		<transition
			name="custom-classes-transition"
    		enter-active-class="animated fadeIn"
    		leave-active-class="animated fadeOut" appear>
			<component :is="overlay.type" v-if="overlay.active"></component>
		</transition>

	</div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import searchBox from '../../components/searchBox.vue'
import SortMenu from '../../components/SortMenu.vue'
import Item from '../../components/Item.vue'
export default {
	mounted()
	{
		this.currentPath = window.location.href;
	},
	created() {
		// console.log("Intro search partial created!");
	},
	data() {
		return {
			currentPath:'',
			menu_categories:[
				{"Id":111100,"hasChildren":false,	path:"New", 				"name":"New","sort":0,"parent":-1,"children":[],"src":"/img/categories/New.png"},				
				{"Id":119,	"hasChildren":false,	path:"Global Conference",	"name":"Global<br/>Conference","sort":1,"parent":-1,"children":[],"src":"/img/categories/Global_Conference.png"},
				{"Id":26,	"hasChildren":true,		path:"Product Materials",	"name":"Product<br/>Materials","sort":10,"parent":-1,"children":[],"src":"/img/categories/Product_Materials.png"},
				{"Id":101,	"hasChildren":false,	path:"Company & Branding",	"name":"Company &<br/>Branding","sort":20,"parent":-1,"children":[],"src":"/img/categories/Company_and_Branding.png"},				
				{"Id":114,	"hasChildren":false,	path:"Lab Technicians",		"name":"Lab<br/>Technicians","sort":30,"parent":-1,"children":[],"src":"/img/categories/Lab_Technicians.png"},
				{"Id":114,	"hasChildren":false,	path:"Clinic's Toolbox",	"name":"Clinic's<br/>Toolbox","sort":40,"parent":-1,"children":[],"src":"/img/categories/Clinic's_Toolbox.png"},
				{"Id":3,	"hasChildren":false,	path:"R&D Materials",		"name":"R&D<br/>Materials","sort":50,"parent":-1,"children":[],"src":"/img/categories/R_and_D_Materials.png"},
				{"Id":76,	"hasChildren":true,		path:"Marketing & Training Tools","name":"Marketing &<br/>Training Tools","sort":60,"parent":-1,"children":[],"src":"/img/categories/Marketing_and_Training_Tools.png"},
				{"Id":115,	"hasChildren":false,	path:"Social Media",		"name":"Social<br/>Media","sort":70,"parent":-1,"children":[],"src":"/img/categories/Social_Media.png"}
			],
			searchfilter: '',
			images:['/img/backgrounds/background-1.jpg'],
			submenu: {
				active:false
			}
		}
	},
	destroyed() {
		// console.log("MENU BAR DESTROYED");
		this.searchFilterString('');
	},
	methods: {
		...mapActions([
			'toggleOverlay',
			'searchFilterString'
		]),
		toggleSub() {
			this.submenu.active = !this.submenu.active
		},
		isInPageUrl(cat)
		{
			let winLoc = this.currentPath.toLowerCase();
			winLoc = winLoc.replace(/%20/g, " ");
			let path = cat.path.toLowerCase();			
			if(winLoc.includes(path))
			{
				///console.log("****TRUE: winLoc="+winLoc+" path="+path);
				return true;
			}
			return false;
			//return if the current url path contains the category 
			//return false;
		},

		getLink(cat) 
		{
			//todo:
			//check the highlighting of the icon 
			//e.g. http://localhost:8383/#/categories/Marketing%20&%20Training%20Tools/Models
			if(cat.hasChildren)
			{
				//display the sub children menu icons				
				return { name: 'sub-menu', params: { category: cat.path } }
			}else{
				//dusplay the result items
				return { name: 'results-root', params: { category: cat.path } }
			}
		}

	},
	watch: {
		$route (to, from){
			this.currentPath = window.location.href;
		},
		'searchfilter'() {
			setTimeout(function() {
				this.searchFilterString(this.searchfilter);
			}.bind(this), 300)
		},
		hasSubmenu() {
			if (!this.hasSubmenu) {
				this.submenu.active = false;
			}
		}
	},
	components: {
		searchBox,
		sortmenu: SortMenu,
		item: Item
	},
	computed: {
		...mapState([
			'overlay',
			'itemsFilterString',
			'categories'
		]),
		...mapGetters([
			'resultsTitle',
			'filterName',
			'isSubmenu',
			'activeCategory',
			'activeCategories'
		]),
		hasSubmenu() {
			return !!(this.$route.name === 'results-child' && this.childCatList.length)
		},
		
		__event() {
			return this.hasSubmenu ? "click" : null;
		},
		currentRoot() {
			let params = this.$route.params,
			name = params.rootFilter;
			if (!!name) {
				return _.find(this.categories, { name });
			}
			return null;
		},
		currentChild() {
			let params = this.$route.params,
			name = params.subcat;
			if (!!name && !!this.currentRoot) {
				return _.find(this.currentRoot.children, { name });
			}
			return null;
		},
		// currentGrandChild() {
		// 	let params = this.$route.params,
		// 	child = this.currentChild,
		// 	name = params.subcat;
		// 	if (!!name && !!root && !!root.children.length) {
		// 		return _.find(root.children, { name });
		// 	}
		// 	return null;
		// },
		childCatList() {
			return this.activeCategory ? this.activeCategories : [];
			// if (this.activeCategory) {
			// 	return this.ac
			// }
			// let cur = this.currentChild || this.currentRoot;
			// return !!cur ? cur.children : []
		},
	}
}
</script>
<style lang="stylus">
@import '~mixins'
@import '~settings'
@import '~rupture'

.font-menubar
	@media (min-width:100px)
		font-size 11px
	@media (min-width:1200px)
		font-size 11px
	@media (min-width:1400px)
		fontsizer(11px, 18px, 1024px, 2400px)

.menu-bar
	//--min-width 768px
	position fixed
	width calc(100% - 110px)
	margin-left 55px
	//@extend $inline-mid
	//--padding-left round(percentage(40/1880))
	height 80px
	background #fff
	z-index 10
	top 100px
	box-shadow 2px 2px 4px rgba(#000, 0.1)
	//border-bottom 1px solid #ccc //rgba(#212121, 0.3)
  	//box-shadow 0px 0px 14.88px 1.12px rgba(142, 142, 142, 0.22)
	+below(815px)
		padding-left 20px
		height 60px
	h4.title
		+below(815px)
			display none
		inline-mid()
		position relative
		height 100%
		span
		.submenu-toggler
			// display inline-block
			// vertical-align middle
			// padding 3px 0 0 16px
			i
				font-size 36px
				color rgba(blue, 0.5)
		& > span
			color #2f2f2f
			padding 0
			margin 0 0 0 36px
			font-size 30px
			font-weight 400
			&.result-label
				margin 0 0 0 10px
			+tablet()
				vertical-align sub
		&.has-submenu
			.result-label
				cursor pointer
				border-bottom 1px solid rgba(blue, 0.5)
				padding-bottom 2px
				span, i
					display inline-block
					vertical-align middle
				i
					color blue
					opacity 0.4
					padding-left 5px
					line-height 1
					font-size 60%
					position relative
					transform-origin center
					will-change transform
					transition transform 0.2s ease-out
				&.active i
					transform translate(25%, 0) rotate(-180deg)
		.arw
			width 1vw
			height @width
			margin-left 1vw
		.submenu
			position absolute
			top 100%
			left 100%
			transform translate(-100%, 0)
			padding 2vh 1vw
			background #fff
			border-radius 0 0 4px 4px
			border 1px solid rgba(#212121, 0.2)
			border-top 0
			z-index -1
			a
				display block
				font-size responsive 16px 20px
				margin-bottom 1vh
				color blue
				white-space nowrap
				transition color 0.2s ease-out, font-weight 0.2s ease-out
				&.router-link-exact-active
					font-weight 400
					color darken(blue, 10)
					pointer-events none
				&:hover
					color darken(blue, 10)
	.menu-search
		position absolute
		right 0
		top 0px
		//..width round(percentage(604/1880))
		width 14%
		max-width 604px
		min-width 12%
		//padding-left round(percentage(49/1880))
		padding-left 2%
		border-left 1px solid #dadada
		height 100%
		+below(815px)
			left 70px
			width calc(100vw - 70px)
	.hamburger
		width 30px
		height 20px
		color #2e2e2e
		border-top 2px solid #2e2e2e
		border-bottom 2px solid #2e2e2e
		position relative
		cursor pointer
		border-radius 0px
		user-select none
		transition width 0.25s ease-out, border-radius 0.25s ease-out, margin-right 0.25s ease-out, color 0.25s ease, border-color 0.25s ease
		&:after
		&:before
			content ''
			width 100%
			position absolute
			top 50%
			left 0
			transform translate(0,-50%)
			height 2px
			background #2e2e2e
			transition width 0.25s ease-out-back, background-color 0.25s ease-out, transform 0.25s ease-out, left 0.25s ease-out
		+desktop()
			&:hover
				border-color darken(blue, 10)
				&:after
					background darken(blue, 10)
		&.active
			border 0
			&:after
				background-color blue
				left 50%
				transform translate(-50%,-50%) rotate(45deg)
			&:before
				background-color blue
				left 50%
				transform translate(-50%,-50%) rotate(-45deg)
			+desktop()
				&:hover
					border-color lighten(blue, 15)
					&:after
					&:before
						// transition width 400ms ease-out-back, background-color 400ms ease
						background lighten(blue, 15)
						width 135%

</style>
